import {
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_COOKIE,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_COOKIE,
} from '@tool-no-hu/shared/constants';

/**
 * Token chỉ tồn tại trong cookie httpOnly do backend set (access_token /
 * refresh_token) — FE không đọc/lưu token trực tiếp (localStorage bị loại bỏ
 * để tránh lộ token qua XSS). File này chỉ còn nhiệm vụ dọn dẹp lúc logout.
 */

function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
}

export function clearTokens(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem('admin_logged_in');
  // Cookie httpOnly được server xoá qua res.clearCookie() ở /auths/logout;
  // các dòng dưới chỉ dọn cookie legacy (nếu có) mà JS có quyền ghi.
  deleteCookie(ACCESS_TOKEN_KEY);
  deleteCookie(REFRESH_TOKEN_KEY);
  deleteCookie(ACCESS_TOKEN_COOKIE);
  deleteCookie(REFRESH_TOKEN_COOKIE);
}
